import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
    MASTER_ACCOUNT_CREATE,
    MASTER_ACCOUNT_CREATE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (symbol, publicKey, privateKey) => {
        const payload = agent.Accounts.createMasterAccount(symbol, publicKey, privateKey);
        dispatch({ type: MASTER_ACCOUNT_CREATE, payload })
    },
    onUnload: () =>
        dispatch({ type: MASTER_ACCOUNT_CREATE_UNLOADED })
});

class MasterAccountAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            symbol: '',
            publicKey: '',
            privateKey: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (symbol, publicKey, privateKey) => ev => {
            ev.preventDefault();
            this.props.onSubmit(symbol, publicKey, privateKey);
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const symbol = this.state.symbol;
        const publicKey = this.state.publicKey;
        const privateKey = this.state.privateKey;
        const inProgress = this.props.inProgress
        return (
            <div class='pane'>
                <Link className="crumb" to="/masteraccounts">&laquo; back to master accounts</Link>
                <h1>Add master account</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(symbol, publicKey, privateKey)}>
                    <fieldset className="form">
                        <strong>Symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Symbol"
                                value={symbol}
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>Public key</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder="Public key"
                                value={publicKey}
                                onChange={this.updateState('publicKey')} />
                        </fieldset>

                        <strong>Private Key</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder="Private Key"
                                value={privateKey}
                                onChange={this.updateState('privateKey')} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Add account
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterAccountAdd);



// WEBPACK FOOTER //
// ./src/components/MasterAccountAdd.js